import React from 'react';

export default function StatTile({ label, value, sub, tone = 'neutral' }) {
  const toneClass =
    tone === 'positive'
      ? 'text-emerald-400'
      : tone === 'negative'
        ? 'text-red-400'
        : 'text-neutral-100';
  return (
    <div className="rounded border border-neutral-800 bg-neutral-900 px-4 py-3">
      <p className="text-xs uppercase tracking-wide text-neutral-500">{label}</p>
      <p className={`text-2xl font-semibold ${toneClass} mt-1`}>{value}</p>
      {sub && <p className="text-xs text-neutral-500 mt-1">{sub}</p>}
    </div>
  );
}
